"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateTag($tag: TagInput!) {
    updateTag(tag: $tag) {
      _id
      name
      createdAt
      updatedAt
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateTag.mutation.js.map